import { Plus } from 'lucide-react';

export interface AddPageButtonProps {
  onAddPage: () => void;
  className?: string;
}

export function AddPageButton({ onAddPage, className = '' }: AddPageButtonProps) {
  return (
    <button
      onClick={onAddPage}
      className={`flex items-center justify-center w-8 h-8 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-colors ${className}`}
      title="Add page"
    >
      <Plus className="h-4 w-4" />
    </button>
  );
}
